
// Custom CSS spinner to replace react-spinkit

const spinnerDiv = {
  position: "fixed",
  zIndex: 3000000,
  width: "100px",
  height: "20px",
  marginLeft: "-50px",
  marginTop: "-50px",
  top: "20%",
  left: "50%",
};

const spinnerStyles = {
  display: "inline-block",
  position: "relative",
  width: "75px",
  height: "25px",
};

const dotStyles = {
  display: "inline-block",
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  backgroundColor: "#007acc",
  animation: "three-bounce 1.4s ease-in-out 0s infinite both",
};

const dot1Styles = {
  ...dotStyles,
  animationDelay: "-0.32s",
};

const dot2Styles = {
  ...dotStyles,
  animationDelay: "-0.16s",
  marginLeft: "8px",
  marginRight: "8px",
};

const dot3Styles = {
  ...dotStyles,
  animationDelay: "0s",
};

// Inject keyframes animation
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes three-bounce {
    0%, 80%, 100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;
if (!document.head.querySelector("style[data-spinner]")) {
  styleSheet.setAttribute("data-spinner", "true");
  document.head.appendChild(styleSheet);
}

const renderSpinner = () => {
  return (
    <div style={spinnerStyles}>
      <div style={dot1Styles}></div>
      <div style={dot2Styles}></div>
      <div style={dot3Styles}></div>
    </div>
  );
};

const Spinner = ({ isLoading }) => {
  return <div style={spinnerDiv}>{isLoading && renderSpinner()}</div>;
};

export default Spinner;
